import React from "react";
import {
  OsiScoreDisplay,
  StaxiScoreDisplay,
  JasScoreDisplay,
  IvaScoreDisplay,
  HolmesRaheScoreDisplay,
  BienestarScoreDisplay,
  CriScoreDisplay,
  Scl90ScoreDisplay,
  BigFiveScoreDisplay,
  TdahScoreDisplay,
  Tdah2ScoreDisplay,
  Tdah3ScoreDisplay,
  BeckScoreDisplay,
} from "./scores";

interface ScoreDisplayProps {
  scores: Record<string, any>;
  interpretations: Record<string, any>;
  scoringType: string;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({
  scores,
  interpretations,
  scoringType,
}) => {
  if (!scores) {
    return (
      <div className="py-4 text-center">
        <p className="text-gray-600 dark:text-gray-400">
          No hay puntuaciones disponibles
        </p>
      </div>
    );
  }

  const renderDefaultScores = () => {
    return (
      <div className="py-4 text-center">
        <p className="text-gray-600 dark:text-gray-400">
          No hay un visualizador específico para este tipo de cuestionario.
        </p>
      </div>
    );
  };

  // Choose renderer based on scoring type
  const renderScores = () => {
    // Add debug logging
    console.log("ScoreDisplay - Rendering for type:", scoringType);
    console.log("ScoreDisplay - Scores data:", scores);
    console.log("ScoreDisplay - Interpretations data:", interpretations);

    switch (scoringType) {
      case "OSI":
        return (
          <OsiScoreDisplay scores={scores} interpretations={interpretations} />
        );
      case "STAXI":
        return (
          <StaxiScoreDisplay
            scores={scores}
            interpretations={interpretations}
          />
        );
      case "JAS":
        return (
          <JasScoreDisplay scores={scores} interpretations={interpretations} />
        );
      case "IVA":
        return (
          <IvaScoreDisplay scores={scores} interpretations={interpretations} />
        );
      case "HOLMES_RAHE":
        return (
          <HolmesRaheScoreDisplay
            scores={scores}
            interpretations={interpretations}
          />
        );
      case "BIENESTAR":
        return (
          <BienestarScoreDisplay
            scores={scores}
            interpretations={interpretations}
          />
        );
      case "CRI":
        return (
          <CriScoreDisplay scores={scores} interpretations={interpretations} />
        );
      case "SCL90":
        return (
          <Scl90ScoreDisplay
            scores={scores}
            interpretations={interpretations}
          />
        );
      // case "BDI":
      //   return <BdiScoreDisplay scores={scores} interpretations={interpretations} />;
      case "BIG_FIVE":
        return (
          <BigFiveScoreDisplay
            scores={scores}
            interpretations={interpretations}
          />
        );
      case "TDAH":
        return (
          <TdahScoreDisplay scores={scores} interpretations={interpretations} />
        );
      case "TDAH2":
        return (
          <Tdah2ScoreDisplay
            scores={scores as any}
            interpretations={interpretations}
          />
        );
      case "TDAH3":
        return (
          <Tdah3ScoreDisplay
            scores={scores as any}
            interpretations={interpretations}
          />
        );
      case "BECK":
        return (
          <BeckScoreDisplay scores={scores} interpretations={interpretations} />
        );
      default:
        return renderDefaultScores();
    }
  };

  return renderScores();
};

export default ScoreDisplay;
